// import React, { useState } from "react";
// import axios from "axios";
// import "./AdminNotificationPanel.css";
// import { FaBell, FaPaperPlane } from "react-icons/fa";

// const AdminNotificationPanel = () => {
//   const [message, setMessage] = useState("");
//   const [title, setTitle] = useState("");
//   const [type, setType] = useState("personal");
//   const [userId, setUserId] = useState("");
//   const [sendToAll, setSendToAll] = useState(true);
//   const [loading, setLoading] = useState(false);

//   const sendNotification = async () => {
//     if (!title.trim() || !message.trim()) {
//       alert("Title and Message are required.");
//       return;
//     }

//     if (!sendToAll && !userId.trim()) {
//       alert("User ID is required to send to a specific user.");
//       return;
//     }

//     try {
//       setLoading(true);

//       const endpoint = sendToAll
//         ? "https://back.varankal.com/notifications/sendadmin"
//         : "https://back.varankal.com/notifications/sendtouser";

//       const payload = sendToAll
//         ? { title, message, type }
//         : { userId, title, message, type };

//       await axios.post(endpoint, payload);

//       alert(
//         sendToAll
//           ? "Notification sent to all users."
//           : "Notification sent to selected user."
//       );

//       // Clear form
//       setTitle("");
//       setMessage("");
//       setUserId("");
//     } catch (error) {
//       console.error("Error sending notification:", error);
//       alert("Error sending notification.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="admin-notification-container">
//       <h2 className="admin-title">
//         <FaBell className="title-icon" /> Notification Management
//       </h2>

//      <div className="notification-form">
//   <div className="notification-toggle form-row">
//     <label>
//       <input
//         type="radio"
//         name="target"
//         checked={sendToAll}
//         onChange={() => setSendToAll(true)}
//       />
//       Send to All Users
//     </label>
//     <label>
//       <input
//         type="radio"
//         name="target"
//         checked={!sendToAll}
//         onChange={() => setSendToAll(false)}
//       />
//       Send to Specific User
//     </label>
//   </div>

//   {!sendToAll && (
//     <div className="form-row">
//       <input
//         type="text"
//         placeholder="Enter User ID"
//         className="notification-input"
//         value={userId}
//         onChange={(e) => setUserId(e.target.value)}
//       />
//     </div>
//   )}

//   <div className="form-row">
//     <input
//       type="text"
//       placeholder="Notification Title"
//       className="notification-input"
//       value={title}
//       onChange={(e) => setTitle(e.target.value)}
//     />
//   </div>

//   <div className="form-row">
//     <textarea
//       placeholder="Notification Message"
//       className="notification-input"
//       value={message}
//       onChange={(e) => setMessage(e.target.value)}
//     />
//   </div>

//   <div className="form-row">
//     <select
//       className="notification-type"
//       value={type}
//       onChange={(e) => setType(e.target.value)}
//     >
//       <option value="personal">Personalized Notification</option>
//       <option value="system">System-wide Announcement</option>
//       <option value="subscription">Subscription Reminder</option>
//       <option value="event">Event Reminder</option>
//       <option value="match">Matchmaking Suggestion</option>
//       <option value="security">Security Alert</option>
//     </select>
//   </div>

//   <button
//     className="send-btn"
//     onClick={sendNotification}
//     disabled={loading}
//   >
//     <FaPaperPlane /> {loading ? "Sending..." : "Send Notification"}
//   </button>
// </div>

//     </div>
//   );
// };

// export default AdminNotificationPanel;

import React, { useState } from "react";
import axios from "axios";
import "./AdminNotificationPanel.css";
import { FaBell, FaPaperPlane } from "react-icons/fa";

const AdminNotificationPanel = () => {
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");
  const [type, setType] = useState("personal");
  const [userId, setUserId] = useState("");
  const [sendToAll, setSendToAll] = useState(true);
  const [loading, setLoading] = useState(false);

  const toggleCheckbox = (option) => {
    if (option === "all") {
      setSendToAll(true);
      setUserId("");
    } else {
      setSendToAll(false);
    }
  };

  const sendNotification = async () => {
    if (!title.trim() || !message.trim()) {
      alert("Title and Message are required.");
      return;
    }

    if (!sendToAll && !userId.trim()) {
      alert("User ID is required.");
      return;
    }

    try {
      setLoading(true);

      const endpoint = sendToAll
        ? "https://back.varankal.com/notifications/sendadmin"
        : "https://back.varankal.com/notifications/sendtouser";

      const payload = sendToAll
        ? { title, message, type }
        : { userId, title, message, type };

      await axios.post(endpoint, payload);

      alert(sendToAll ? "Notification sent to all users." : "Notification sent to user.");

      setTitle("");
      setMessage("");
      setUserId("");
    } catch (error) {
      console.error(error);
      alert("Error sending notification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-card">

        <h2 className="admin-header">
          <FaBell className="header-icon" /> Notification Panel
        </h2>

        <div className="two-column">

          {/* LEFT COLUMN */}
          <div className="left-col">

            <div className="form-section">
              <label className="section-title">Send To</label>

              <div className="checkbox-row">
                <label className="checkbox-item">
                  <input
                    type="checkbox"
                    checked={sendToAll}
                    onChange={() => toggleCheckbox("all")}
                  />
                  <span>All Users</span>
                </label>

                <label className="checkbox-item">
                  <input
                    type="checkbox"
                    checked={!sendToAll}
                    onChange={() => toggleCheckbox("specific")}
                  />
                  <span>Specific User</span>
                </label>
              </div>
            </div>

            {!sendToAll && (
              <div className="form-section">
                <label className="section-title">User ID</label>
                <input
                  type="text"
                  className="input-box"
                  placeholder="Enter User ID"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>
            )}

            <div className="form-section">
              <label className="section-title">Notification Type</label>
              <select
                className="input-box"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="personal">Personalized</option>
                <option value="system">System Announcement</option>
                <option value="subscription">Subscription Reminder</option>
                <option value="event">Event Reminder</option>
                <option value="match">Matchmaking Suggestion</option>
                <option value="security">Security Alert</option>
              </select>
            </div>

          </div>

          {/* RIGHT COLUMN */}
          <div className="right-col">

            <div className="form-section">
              <label className="section-title">Title</label>
              <input
                type="text"
                className="input-box"
                placeholder="Enter Notification Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="form-section">
              <label className="section-title">Message</label>
              <textarea
                className="textarea-box"
                placeholder="Enter Notification Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>

            <button
              className="send-btn"
              onClick={sendNotification}
              disabled={loading}
            >
              <FaPaperPlane /> {loading ? "Sending..." : "Send Notification"}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminNotificationPanel;
